// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__zS3Qp","legacyBtn":"MutateMid_legacyBtn__3kzNH"};